import { Chip, Skeleton } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useVenueCoupons } from '../hooks/useCoupons';

interface CouponCountBadgeProps {
  venueId: string;
  onClick?: () => void;
}

export function CouponCountBadge({ venueId, onClick }: CouponCountBadgeProps) {
  const { data, isLoading } = useVenueCoupons(venueId);

  if (isLoading) {
    return <Skeleton variant="rounded" width={150} height={32} />;
  }

  if (!data?.totalCouponCount) {
    return null;
  }

  return (
    <Chip
      icon={<LocalOfferIcon fontSize="small" />}
      label={`${data.totalCouponCount} ${data.totalCouponCount === 1 ? 'offer' : 'offers'} available`}
      color="success"
      variant="outlined"
      onClick={onClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? { backgroundColor: 'success.light', opacity: 0.1 } : undefined,
      }}
    />
  );
}
